module.exports = __webpack_public_path__ + "static/media/image.0e0463c3.svg";